// extracted by mini-css-extract-plugin
export default {"menuDropdownBannerSlot":"menuDropdownBrazeBanner_menuDropdownBannerSlot__m7Jei"};